export default __webpack_public_path__ + "static/media/ivt.b2fa04b3.pdf";